import * as React from 'react';

import { Box } from '@library/Box';
import { Logo, LogoProps } from '@library/Logo';
import { Typography } from '@library/Typography';
import { Rows } from '@library/layout/Rows';

type Props = {
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  logoType?: LogoProps['type'];
  children?: React.ReactNode | null | undefined;
};

export const PromptHeader = ({
  title,
  logoType = 'word',
  subtitle,
  children,
}: Props) => (
  <Rows spacing={1} paddingX={2} alignItems="center">
    {logoType && (
      <Box sx={{ paddingBottom: 1 }}>
        <Logo
          type={logoType}
          color="primary"
          height={logoType === 'icon' ? 64 : 16}
        />
      </Box>
    )}
    {title && <Typography variant="h3">{title}</Typography>}
    {subtitle && (
      <Typography sx={{ textAlign: 'center' }}>{subtitle}</Typography>
    )}
    {children && <Box>{children}</Box>}
  </Rows>
);
